import { render } from "./teacherCockpit.vue?vue&type=template&id=7c0261c2&scoped=true"
import script from "./teacherCockpit.vue?vue&type=script&lang=js"
export * from "./teacherCockpit.vue?vue&type=script&lang=js"

import "./teacherCockpit.vue?vue&type=style&index=0&id=7c0261c2&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0261c2"]])

export default __exports__